module.exports = __webpack_public_path__ + "img/sociallogin.008d6763.svg";